export const AwsAccountIdRegex = /^\d{12}$/;

export const AwsIamRoleArnRegex =
  /^arn:aws[a-zA-Z-]*:iam::\d{12}:role\/[\w+=,.@/-]+$/;

export const AwsRegionRegex = /^[a-z]{2}(?:-[a-z0-9]+)+-\d$/;

export const AwsStsExternalIdRegex = /^[\w+=,.@:/-]{2,1224}$/;
